const userQueryKeys = {
    current: () => ['user'],
};

export { userQueryKeys };
